'use client';

import { useEffect } from 'react';
import * as CookieConsent from 'vanilla-cookieconsent';
import getConsentConfig from './ConsentCookieConfig';

const ConsentCookieLayer = () => {
  useEffect(() => {
    CookieConsent.run(getConsentConfig('es'));
  }, []);

  return (
      <></>
  );
};

export default ConsentCookieLayer;
